import { useNavigate } from 'react-router-dom';
import { getEndpointWithParams } from '@/routes/config';
import * as Styles from './TopPageLinks.styles';
import GoBackButton from '../GoBackButton';

export type PageLink = {
  label: string;
  to: { path: string; params?: Record<string, string> };
  isActived?: boolean;
  isDisabled?: boolean;
};

export type TopPageLinksProps = {
  pageLinks: PageLink[];
  hideBackButton?: boolean;
  backTo?: string;
  className?: string;
};

const TopPageLinks = ({
  pageLinks: allowedPageLinks,
  className,
  hideBackButton = false,
  backTo,
}: TopPageLinksProps): JSX.Element => {
  const navigate = useNavigate();

  const goBack = (): void => (backTo ? navigate(backTo) : navigate(-1));

  return (
    <Styles.LinksArea className={className}>
      {!hideBackButton && <GoBackButton onClick={goBack} />}
      {allowedPageLinks.map((link) => (
        <Styles.LinkWrapper
          key={link.label}
          isActived={link.isActived}
          isDisabled={link.isDisabled}
        >
          <Styles.TopBarLink to={getEndpointWithParams(link.to.path, link.to.params || {})}>
            {link.label}
          </Styles.TopBarLink>
        </Styles.LinkWrapper>
      ))}
    </Styles.LinksArea>
  );
};

export default TopPageLinks;
